import { isEmpty, isNil } from 'lodash';
import { convertSlashToKebab } from './conversions';
import { IOrderParams } from '../../../../API/pcDashboard/getOrderAsync';
import { eSearchOrdersOrderBy } from '../../../../ui-toolkit/orders/searchOrder/types/eSearchOrdersOrderBy';

const isNilOrEmptyArrayOrEmptyString = (value: unknown) => {
  if (isNil(value)) {
    return true;
  }
  if (Array.isArray(value)) {
    return isEmpty(value);
  }
  if (typeof value === 'string') {
    return isEmpty(value);
  }
  return false;
};

const dateKeys = new Set<string>(['closingDateStart', 'closingDateEnd']);
const dateTimeKeys = new Set<string>(['createdAtStart', 'createdAtEnd']);
const excludedRuleKeys = new Set<string>(['excludeCanceledOrders', 'excludeInactiveOrders']);

export function cleanMultiSelectQueryRequest(values: Partial<IOrderParams>): IOrderParams {
  const creationDateTime = getCreationDateTime(values);
  const cleanedValues: Partial<IOrderParams> = { ...creationDateTime };
  for (const key in values) {
    const value = values[key];
    if (isNilOrEmptyArrayOrEmptyString(value)) {
      continue;
    }
    if (dateKeys.has(key)) {
      cleanedValues[key] = convertSlashToKebab(value);
      continue;
    }
    if (dateTimeKeys.has(key)) {
      continue;
    }
    if (excludedRuleKeys.has(key)) {
      if (value) {
        cleanedValues[key] = value;
      }
      continue;
    }
    cleanedValues[key] = value;
  }
  return {
    ...cleanedValues,
    pageNumber: cleanedValues.pageNumber ?? 0,
    pageSize: cleanedValues.pageSize ?? 20,
    sortBy: cleanedValues.sortBy ?? eSearchOrdersOrderBy.createdAtDESC,
  };
}

const getCreationDateTime = (values: Partial<IOrderParams>) => {
  try {
    if (values.createdAtStart && values.createdAtEnd) {
      // range or exact date
      const adjustedStart = new Date(values.createdAtStart);
      adjustedStart.setUTCHours(0, 0, 0, 0);
      const adjustedEnd = new Date(values.createdAtEnd);
      adjustedEnd.setUTCHours(23, 59, 59, 999);
      return {
        createdAtStart: adjustedStart.toISOString(),
        createdAtEnd: adjustedEnd.toISOString(),
      };
    }
    if (values.createdAtStart && !values.createdAtEnd) {
      // After case
      const date = new Date(values.createdAtStart);
      date.setUTCHours(23, 59, 59, 999);
      return {
        createdAtStart: date.toISOString(),
      };
    }
    if (values.createdAtEnd && !values.createdAtStart) {
      // Before case
      const date = new Date(values.createdAtEnd);
      date.setUTCHours(0, 0, 0, 0);
      return {
        createdAtEnd: date.toISOString(),
      };
    }
    return {};
  } catch (error) {
    return {};
  }
};
